import { TenantTemplateRouterCore } from "@components/tenant/TenantTemplateRouter";
import DefaultInvoicePrint from "./default";

const templates = import.meta.glob<{ default: React.ComponentType<any> }>(
  "/src/pages/user/Debitnotes/Print/templates/*/index.tsx"
);

type DebitnotePrintProps = {
};

export default function DebitnotePrint(props: DebitnotePrintProps) {
  return (
    <TenantTemplateRouterCore<DebitnotePrintProps>
      templates={templates}
      DefaultComponent={DefaultInvoicePrint}
      passProps={props}
    />
  );
}